<template>

    <div>

        <!-- <div class="main-sidemenu-open-overlay" v-if="mainSidebarShown" @click="showMainSidebar()"></div> -->

        <div class="topbar" >

            <div class="topbar__logo text-center">
                <svg id="heaps-logo" width="25px" height="27.78px" viewBox="0 0 170 189" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g transform="translate(0.000000, -3.000000)" fill="#1c8ff3">
                            <g id="heap-squares" transform="translate(0.000000, 3.000000)">
                                <rect id="bottom-right-square" x="117" y="136" width="53" height="53" rx="7"></rect>
                                <rect id="bottom-left-square" x="0" y="136" width="53" height="53" rx="7"></rect>
                                <rect id="center-right-square" x="127" y="72" width="42" height="42" rx="7"></rect>
                                <rect id="center-center-square" x="64" y="72" width="42" height="42" rx="7"></rect>
                                <rect id="center-left-square" x="0" y="72" width="42" height="42" rx="7"></rect>
                                <rect id="top-right-square" x="117" y="0" width="53" height="53" rx="7"></rect>
                                <rect id="top-left-square" x="0" y="0" width="53" height="53" rx="7"></rect>
                            </g>
                        </g>
                    </g>
                </svg>
            </div>

            <div class="topbar__show-sidebar topbar__action">
                <i :class="!mainSidebarShown ? 'fas fa-bars' : 'fas fa-times'" @click="showMainSidebar($el)" v-if="showMainSideBarBtn"></i>
            </div>

            <div class="topbar__back-to-elements topbar__action">
                <div @click="backToElementList" v-if="showBackToElementsButton">
                    <i class="fas fa-th"></i>
                    <span>Back to Elements</span>
                </div>
            </div>

            <div class="topbar__account-info topbar__action" v-b-modal="'my-account-modal'">
                <i class="far fa-user"></i> 
                <span>My Account</span> 
            </div>

            <div class="topbar__notifications topbar__action" v-b-modal="'notifications-modal'">
                <i class="far fa-bell"></i>
                <span>3</span>
            </div>

            <div class="topbar__save" @click="saveElement" v-if="showSaveBtn">
                <i class="fas fa-check"></i> 
                <span>save</span> 
            </div>

        </div>

        <div class="loading-overlay" v-if="savingSpinner">
            
            <div class="spinner-save">
                <b-spinner variant="primary" label="Saving" />
                <div class="spinner-save-text">
                    Saving Settings
                </div>
            </div>
                
        </div>
    
    </div>
</template>

<script>
export default {
    name: 'Topbar',
    data () {
        return {
            mainSidebarShown: false
        }
    },
    methods: {

        showMainSidebar(el) {

            this.mainSidebarShown = !this.mainSidebarShown

            this.mainSidebarShown 
            ? document.body.classList.add('right-pull')
            : document.body.classList.remove('right-pull')

        },

        // show elements panel again
        backToElementList() {
            this.$store.state.weeblySettings.name = 'SelectElements'
            document.querySelector('.preview-box').classList.remove('active')
        },
        // save element
        saveElement() {


            if( this.$store.state.weeblySettings.name === "Blocks") {
                if(document.querySelector('.jarallax')){
                    console.log('we destroyed jarallax here in saving')
                    jarallax(document.querySelectorAll('.jarallax'), 'destroy');
                }
                if( document.querySelector('.block-with-video-bg') ) {
                    console.log('we have video child block \n how can we fix this now!!!')
                }
            }

            // content slider
            if( this.$store.state.weeblySettings.name === "BlogcardsSlider" || this.$store.state.weeblySettings.name === "TestimonialSlider" || this.$store.state.weeblySettings.name === "ImageSlider" || this.$store.state.weeblySettings.name === "ContentSlider" || this.$store.state.weeblySettings.name === "ContentSliderCarousel") {
                this.$store.state.weeblySettings.settings.slideReordering = false
                console.log('disable flickity here');
                // flkty.destroy()
                if(document.querySelector('.bundle-content-slider')) {
                    console.log('it does exist')
                    var flkty = new Flickity( '.bundle-content-slider', {
                    // options
                    });
                    flkty.destroy();

                }else {
                    console.log('it does not exist')
                }
            }

            // aos
            if(this.$store.state.weeblySettings.name === "AnimateOnScroll") {
                
                // remove aos class instances
                document.querySelector('.preview-box .bundle-animation-on-scroll-block').classList.remove('aos-init','aos-animate');
            }
            

            // remove element guide from block child
            this.$store.state.showBlockChildSettingsGuide = false

            // element help lines for dashboard only
            this.$store.state.elementGuidesOnlyDashboard = false

            // set save overlay
            this.$store.state.savingOverlay = true

            // check which device is currently active
            let tempDevice = '';
            if(this.$store.state.deviceStyles.desktopStyles) {
                tempDevice = 'desktopStyles'
            }
            if(this.$store.state.deviceStyles.tabletStyles){
                tempDevice = 'tabletStyles'
            }
            if(this.$store.state.deviceStyles.mobileStyles) {
                tempDevice = 'mobileStyles'
            }
            // make sure to hide the small devices styles - we don't need these styles for end element
            this.$store.state.deviceStyles.desktopStyles = false
            this.$store.state.deviceStyles.tabletStyles = false
            this.$store.state.deviceStyles.mobileStyles = false

            // remove back to elements this can not be shown again
            this.$store.state.showBackToElements = false

            // get all google fonts
            var allGFonts = this.$store.state.googleFontsToLoad
            var gFonts = allGFonts.toString()
            if(allGFonts.length > 0){
                gFonts = gFonts.replace(/,/g, '|');
            }

            console.log('all fonts: ',gFonts)


            
            // update Weebly settings
            setTimeout( () => {
                console.log('we should update settings for weebly now')
                // get inner div content for markup
                var innerDiv = document.querySelector('.preview-box.active').innerHTML;

                var innerDivStrip = innerDiv.replace(/<!---->/g, "")

                innerDivStrip = innerDivStrip.replace(/contenteditable="false"/g, '');

                var innerDivStrip2 = innerDivStrip.replace(/draggable="false"/g, "")

                innerDivStrip2 = innerDivStrip2.trim();

                var weeblyEditorMarkup = '';

                // Weebly editor only markup for Blogcardslider
                if( this.$store.state.weeblySettings.name === "BlogcardsSlider" || this.$store.state.weeblySettings.name === "Blogcards" ) {
                    var weebEditorText = ''

                    if(this.$store.state.weeblySettings.name === "BlogcardsSlider"){
                        weebEditorText = 'BLOG CARDS CAROUSEL WILL LOAD ON YOUR LIVE SITE'
                    }
                    if(this.$store.state.weeblySettings.name === "Blogcards"){
                        weebEditorText = 'BLOG CARDS WILL LOAD ON YOUR LIVE SITE'
                    }

                    console.log('we need special Weebly editor markup')
                    weeblyEditorMarkup = '<div style="margin:10px auto;font-family:\'Helverica Neue\', Arial, sans-serif;background: #1C8FF3;background: linear-gradient(135deg, rgba(28,141,243,1) 1%,rgba(91,84,246,1) 100%);color:#fff; border:1px solid #1C8FF3;border-radius: 3px;letter-spacing:.04em;padding:15px 15px 15px 45px;text-align:center;font-size:14px;position:relative;overflow:hidden;"> <div style="position:absolute;left:0;top:0; height:100%;width:45px;background:#fff;border-right:1px solid #1C8FF3;"> <svg style="display:inline-block;position:relative;transform:translateY(-50%);top:50%;" width="30px" height="27.88px" viewBox="0 0 85 79" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="heap-icon-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="heap-icon-2" transform="translate(1.000000, -36.000000)" stroke="#1C8FF3"> <g id="heap-icon-3" transform="translate(0.000000, 37.000000)"> <g id="heap-icon-4" transform="translate(14.000000, 15.000000)" stroke-width="3"> <path d="M33.0797101,1.23214286 L0.398550725,45.5892857" id="Path-3"></path> <path d="M33.8768116,30.8035714 L21.9202899,45.5892857" id="Path-3-Copy" transform="translate(27.898551, 38.196429) scale(-1, 1) translate(-27.898551, -38.196429) "></path> <path d="M54.6014493,1.23214286 L44.2391304,15.1964286" id="Path-3-Copy-2" transform="translate(49.420290, 8.214286) scale(-1, 1) translate(-49.420290, -8.214286) "></path> </g> <g id="heap-icon-5" fill="#1C8FF3"> <ellipse id="Oval" cx="53.4711538" cy="9.10752688" rx="8.77884615" ry="9.10752688"></ellipse> <ellipse id="Oval-Copy" cx="31.125" cy="38.0860215" rx="8.77884615" ry="9.10752688"></ellipse> <ellipse id="Oval-Copy-2" cx="8.77884615" cy="67.8924731" rx="8.77884615" ry="9.10752688"></ellipse> <ellipse id="Oval-Copy-3" cx="53.4711538" cy="67.8924731" rx="8.77884615" ry="9.10752688"></ellipse> <ellipse id="Oval-Copy-4" cx="74.2211538" cy="38.0860215" rx="8.77884615" ry="9.10752688"></ellipse> </g> </g> </g> </g></svg> </div>'+weebEditorText+'</div>'
                } else {
                    weeblyEditorMarkup = innerDivStrip2
                }

                console.log()



                parent.postMessage({
                    action: "settings:update",
                    data: {
                        // update element name in Weebly setting
                        'elementName': this.$store.state.weeblySettings.name,
                        // update element html in Weebly setting
                        'html_output': innerDivStrip2,
                        // update element html in Weebly setting in editor
                        'html_output_editor': weeblyEditorMarkup,
                        // update element settings in Weebly setting
                        'settingsOutput': JSON.stringify(this.$store.state.weeblySettings.settings),
                        // fonts google
                        'onEx3': '<link href="https://fonts.googleapis.com/css?family='+gFonts+'" rel="stylesheet">'
                    }
                }, window.frameOrigin);
                
                if(document.querySelector('.jarallax')){
                    jarallax(document.querySelectorAll('.jarallax'))
                    console.log('we will need to revise reload of video here')
                }

                // show element guide from block child
                this.$store.state.showBlockChildSettingsGuide = true

                // show element help lines for dashboard only
                this.$store.state.elementGuidesOnlyDashboard = true

                console.log('tempDevice is: ', tempDevice)
                if(tempDevice !== ''){
                    this.$store.state.deviceStyles[tempDevice] = true
                }

                // create it to destroy it
                // var flkty = new Flickity( '.bundle-content-slider');
                // destroy it
                // flkty.destroy();

                // this.$store.state.weeblySettings.settings.flickityStart()

            }, 2500)            

            
        }
    },
    computed: {    
        showSaveBtn() {
            return this.$store.state.showSaveBtn
        },
        showBackToElementsButton() {
            return this.$store.state.showBackToElements
        },
        showMainSideBarBtn() {
            return this.$store.state.showSettingsBar
        },
        savingSpinner() {
            return this.$store.state.savingOverlay
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import '../../less/colors.less';

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    overflow: hidden;
    z-index: 1000;
    background: rgba(0,0,0,.7);

    div.spinner-save {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        padding: 15px;
        border-radius: .25rem;
        background: rgba(0,0,0,.5);
        box-shadow: 0 7px 18px rgba(0,0,0,.3);

        .spinner-save-text {
            color: rgba(255,255,255,.5);
            text-transform: uppercase;
            font-weight: 700;
            margin-top: 20px;
            font-size: 12px;
            letter-spacing: .03em;
        }

    }
}

.topbar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    line-height: 60px;
    z-index: 20;
    background: #fff;
    border-bottom: 1px solid @border_grey_medium;
    display: flex;
    box-shadow: 0 7px 17px rgba(216, 221, 229, 0.7);

    .topbar__logo {
        width: 75px;
        color: @action_blue;
        background: @shark_teeth;
        border-right: 1px solid @border_grey_medium;

        svg {
            width: 25px;
            height: auto;
        }
    }

    .topbar__action:not(.topbar__show-sidebar) {
        padding: 0 30px;

        span {
            font-weight: 700;
            color: @text_grey;
            font-size: 13px;
        }

        i {
            color: fade(@text_grey,70%);
            margin-right: 7px;
        }

        &:hover, &:hover i {
            color: fade(@text_grey,90%);

        }
    }
}
.topbar__show-sidebar {
    flex: 1;

    i {
        width: 75px;
        text-align: center;
        height: 60px;
        line-height: 60px;
        cursor: pointer;
        color: @subtitle_grey;

    }
    
}

.topbar__back-to-elements > div {
    display: inline-block;
    cursor: pointer;
}

.topbar__notifications, .topbar__account-info {
    cursor: pointer;
}
.topbar__save {
    padding: 0 45px;
    background: @action_blue;
    color: #fff;
    font-weight: 700;
    cursor: pointer;

    &:hover {
        background: @spark_green;
    }
}
.main-sidemenu-open-overlay {
    position: fixed;
    top: 75px;
    left: 75px;
    bottom: 0;
    right: 0;
    overflow: hidden;
    background: fade(@text_grey, 70%);
    z-index: 20;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Topbar.vue